import getFilterWithCol from '../../helpers/getFilterWithCol';

import Types from '../../modules/types';

import {
  // filterSortHidden,
  filterStoreGlobal as filterStore,
  filterGlobal,
} from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => {
    if (value?.length) {
      const valueRegex = Types.getSafeSearchRegex(value);
      builder.add(
        'where',
        {
          OR: ['name'].map(key => ({
            [key]: { REGEX: valueRegex, OPTIONS: 'i' },
          })),
        },
      );
    }
  },
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
      ? undefined
      : value.target
        ? value.target.value
        : value;
    return !value || !value.length
      ? undefined
      : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search pricing name',
  }],
}];

export const filterPopulate = ['FilterHidden', {
  id: 'populate',
  section: 'top',
  buildQuery: (value, builder) => {
    builder.add('populate', {
      store: {
        _id: true,
        name: true,
      },
    });
    builder.add('populate', {
      ...(
        Types.SHIPPING_PRICING_METHOD.reduce(
          (agr, pricingMethod) => {
            agr[`methods.${pricingMethod}.shippingCompany`] = true;
            return agr;
          },
          {},
        )
      ),
    });
  },
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterGlobal, 12],
    [filterStore, 24],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  // filterSortHidden,
  filterPopulate,
  filterPagination,
];
